export default __webpack_public_path__ + "static/media/ar_2020_image.b56cba95.png";